import { useAppSelector } from '../store';

export default () => useAppSelector(({ root: { user } }) => user);
